/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMilk = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7.969 5H16.5L20 9.667V22H4V9.63L7.969 5zm2.693 2 1.786 2H17l-1.5-2h-4.838zM18 11h-5v9h5v-9zm-7 9v-9.618L8.444 7.519 6 10.369V20h5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMilk as Milk };
